<template>
  <div 
    class="c-map-popup-car-content"
    :style="`font-size: ${font_size}px`"
  >
    <ul>
      <li>
        Номер ТЗ: 
        <b>{{ item.number }}</b>
      </li>
      <li>
        Напрямок ТЗ: 
        <b>{{ classVehicle.direction(item.direction) }}</b>
      </li>
      <li>
        Наступне ТЗ: 
        <b>{{ classVehicle.nextNumber(item) }}</b>
      </li>
      <li>
        Попереднє ТЗ: 
        <b>{{ classVehicle.previousNumber(item) }}</b>
      </li>
      <li>
        Відстань до наступного ТЗ: 
        <b>{{ classVehicle.distance(item.distanceToNextVehicle) }}</b>
      </li>
      <li>
        Відстань до попереднього ТЗ: 
        <b>{{ classVehicle.distance(item.distanceToPreviousVehicle) }}</b>
      </li>
      <li>
        Час до наступного ТЗ: 
        <b>{{ classTime.toMin(item.timeToNextVehicle) }}</b>
      </li>
      <li>
        Час до попереднього ТЗ: 
        <b>{{ classTime.toMin(item.timeToPreviousVehicle) }}</b>
      </li>
      <li>
        Час до наступної зупинки: 
        <b>{{ classTime.toMin(item.timeToNextStop) }}</b>
      </li>
      <li>
        Службова інформація:<br>
        <b v-html="classVehicle.debugInfo(item)"></b>
      </li>
    </ul>
  </div>
</template>

<script>
import { ClassTime } from '@/helpers/base'
import { ClassVehicle } from '@/helpers/cars'
export default {
  name: 'c-map-popup-car-content',
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    font_size: {
      type: Number,
      default: 12
    },
  },
  data() {
    return {
      classTime: new ClassTime(),
      classVehicle: new ClassVehicle()
    }
  }
}
</script>

<style lang="scss">
  .c-map-popup-car-content {
    b {
      font-weight: 600;
    }
    ul {
      list-style: none;
      padding: 0 !important;
      text-align: left;
    }
    li {
      padding: 2px 5px;
      white-space: nowrap;
    }
  }
</style>